// Options for react-select menu
export const options = [
  { value: 'jpg', label: 'JPEG' },
  { value: 'png', label: 'PNG' },
];
